const useCaseCollectList = () => import('@/views/pages/useCase/useCaseCollectList/index.vue');
const useCaseSquare = () => import('@/views/pages/useCase/useCaseSquare/index.vue');

const UseCaseRouteList = [
  {
    path: 'useCaseCollectList',
    component: useCaseCollectList,
    name: '/useCaseCollectList',
    meta: {
      ownType: 'useCaseContent',
      lableTitle: 'Use Case Square',
      mid: '4a9d-7b1c',
    },
  },
  {
    path: 'useCaseSquare',
    component: useCaseSquare,
    name: '/useCaseSquare',
    meta: {
      ownType: 'useCaseContent',
      lableTitle: 'Use Case Square',
      mid: '1f0e-8d53',
    },
  },
];

export default UseCaseRouteList;
